import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "configuration"
    }}>{`Configuration`}</h1>
    <p>{`This section describes options for programmatically managing configuration settings with Adobe Commerce and Magento Open Source components.`}</p>
    <p>{`Topics include:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "importers.md"
        }}><strong parentName="a">{`Configuration importers`}</strong></a>{`—Standardize configuration settings across multiple systems with configuration importers.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sensitive-environment-settings.md"
        }}><strong parentName="a">{`Sensitive and system-specific environment settings`}</strong></a>{`—Create components that designate configuration settings as being sensitive, system-specific, or both.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      